<template>
  <Breadcrumb :home="home" :model="items">
    <template #item="{ item, props }">
      <router-link v-if="item.route" v-slot="{ href, navigate }" :to="item.route" custom>
        <a :href="href" v-bind="props.action" @click="navigate">
          <span class="text-lg font-medium hover:text-[var(--color-black)] hover:font-bold"
            :class="{'text-black underline':item.isActive}">
            {{ item.label }}</span>
        </a>
      </router-link>
      <a v-else :href="item.url" :target="item.target" v-bind="props.action">
        <span class="text-lg text-surface-700 dark:text-surface-0">{{ item.label }}</span>
      </a>
    </template>
   </Breadcrumb>
</template>

<script scoped>
import { Breadcrumb } from 'primevue';

export default {
  name: 'BreadcrumbsComponent',
  components: { Breadcrumb },
  props: ['breadCrumbs'],
  data() {
    return {
      home: {
        route: '/',
        isActive: false,
        label: 'HOME',
      },
      items: this.breadCrumbs,
    };
  },
};
</script>
